import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VaccinesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vaccines"}/>
}
